module.exports = __webpack_public_path__ + "static/img/7.f8816f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/sp/7.png
// module id = E5d4
// module chunks = 0